import { useState } from 'react';
import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import '../styles/Editors.scoped.scss';

export const SurveyFieldEditor = ({ field, onChange }: FieldEditorProps) => {

    const [campaignId, setCampaignId] = useState<number|null>(null);
    const [questionId, setQuestionId] = useState<number|null>(field?.questionId);

    return <>
        <div className="field-editor-row">
            <label>Campaign</label>
            <div className='field-editor-input'>
                <AsyncSelect
                    entity="campaign"
                    value={campaignId}
                    rootClassName="grow"
                    onChange={(id) => setCampaignId(id)}
                    />
            </div>
        </div>
        {(campaignId || questionId) && 
        <div className="field-editor-row">
            <label>Question</label>
            <div className="field-editor-input">
                <AsyncSelect
                    entity="question"
                    value={questionId}
                    rootClassName="grow"
                    onChange={(id) => onChange({ questionId: id })}
                    queryParameters={{
                        campaignId: campaignId,
                    }}
                    />
            </div>
        </div>}
    </>
}